<script>
    export let data = {}

    const { content } = data
</script>

<div class="modal-body">
    {@html content}
</div>
